import { useEffect, useRef } from 'react';
import QRCode from 'qrcode';

const QRCodeComponent: React.FC<{ text: string }> = ({ text }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas) {
      const parent = canvas.parentElement;
      if (parent) {
        const width = parent.clientWidth;
        const height = parent.clientHeight;

        // Set canvas resolution to match display size
        canvas.width = width;
        canvas.height = height;

        QRCode.toCanvas(canvas, text, {
          width: width, // ensures QR code fills canvas
        }, (error) => {
          if (error) console.error(error);
        });
      }
    }
  }, [text]);

  return (
    <canvas
      ref={canvasRef}
      style={{
        width: '100%',
        height: '100%',
        display: 'block',
      }}
    />
  );
};

export default QRCodeComponent;
